
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ZoomMeetingTimelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ZoomMeeting"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transcript"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transcriptionSummary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntitySummaryFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":248}};
    doc.loc.source = {"body":"#import \"../../../timeline-summary/graphql/fragments/entity-summary-fragment.graphql\"\n\nfragment ZoomMeetingTimelineFragment on ZoomMeeting {\n    id\n    transcript\n    recordingUrl\n    transcriptionSummary {\n        ...EntitySummaryFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../../../timeline-summary/graphql/fragments/entity-summary-fragment.graphql").definitions));


      module.exports = doc;
    
